module.exports = __webpack_public_path__ + "assets/thumbs_down.fa171758dd411c0c2cd9f0b831b27879.png";